import { render, staticRenderFns } from "./OxyClassTokenActions.vue?vue&type=template&id=5012745e&"
import script from "./OxyClassTokenActions.vue?vue&type=script&lang=ts&"
export * from "./OxyClassTokenActions.vue?vue&type=script&lang=ts&"
import style0 from "./OxyClassTokenActions.vue?vue&type=style&index=0&id=5012745e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports